import React from 'react';
import { createOverdueModalOptions } from 'modals/modal-options-factory';
import Background from 'components/Background';
class Overdue extends React.Component {
  componentDidMount() {
    const { toggleModal } = this.props;
    const options = createOverdueModalOptions();
    toggleModal(options);
  }

  render() {
    return <Background />;
  }
}

export default Overdue;
